import Distillations from "../../pages/Distillations";
import ProcessDistillations from "../../pages/Distillations/ProcessDistillations";
import NewDistillationExperiment from "../../pages/Distillations/CreateDistillationTabs/NewDistillationExperiment";
import { InternalUserRoles, Roles } from "../../constants/roles";
import { ReactComponent as DistillationsIcon } from "../../assets/distillationsicon.svg";
import { ModuleRouteConfig, RouteConfig } from "../types";

export const BASE_PATH = "/distillations";

const DistillationWorkerRoles = [Roles.DistillationWorker, Roles.Developer];


export const baseRoute: ModuleRouteConfig = {
  path: BASE_PATH,
  component: Distillations,
  allowedRoles: InternalUserRoles,
  label: "Distillations",
  icon: () => <DistillationsIcon />,
  isCustomIcon: true,
  hasDivider: false,
};

export const distillationsRoutes: { [key: string]: RouteConfig } = {
  distillations: baseRoute,
  processDistillations: {
    path: "/processDistillation",
    component: ProcessDistillations,
    allowedRoles: DistillationWorkerRoles,
  },
  newDistillationExperiment: {
    path: "/newExperiment",
    component: NewDistillationExperiment,
    allowedRoles: InternalUserRoles,
  },
};
